module.exports = __webpack_public_path__ + "static/media/texas-nm-locations.3ca5fd48.svg";